import { render } from "./Detalhes.vue?vue&type=template&id=16f4d40b&scoped=true"
import script from "./Detalhes.vue?vue&type=script&lang=js"
export * from "./Detalhes.vue?vue&type=script&lang=js"

import "./Detalhes.vue?vue&type=style&index=0&id=16f4d40b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16f4d40b"]])

export default __exports__